import { Controller } from "@hotwired/stimulus"

// Admin-only: subscribes this browser to Web Push so RSVP changes ping the
// installed PWA. Lives on the top bar: until subscribed, a prominent
// "notify me" pill (cta target) is shown; once subscribed it moves into the
// dropdown as a passive "notifications on" row (menuItem target).
// Unsupported browsers show neither. On iOS this only works from the
// installed app.
export default class extends Controller {
  static targets = ["cta", "menuItem"]
  static values = { vapidKey: String, url: String }

  async connect() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return
    const registration = await navigator.serviceWorker.register("/service-worker")
    const subscription = await registration.pushManager.getSubscription()
    if (subscription && Notification.permission === "granted") {
      this.markEnabled()
    } else {
      this.ctaTarget.hidden = false
    }
  }

  async subscribe() {
    const permission = await Notification.requestPermission()
    if (permission !== "granted") return

    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.vapidKeyValue
    })

    const { endpoint, keys } = subscription.toJSON()
    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ endpoint: endpoint, p256dh_key: keys.p256dh, auth_key: keys.auth })
    })
    if (response.ok) this.markEnabled()
  }

  markEnabled() {
    this.ctaTarget.hidden = true
    if (this.hasMenuItemTarget) this.menuItemTarget.hidden = false
  }
}
